// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import newsletterOptOutEntity from './entities/newsletter-opt-out.json';
import newsletterOptOutMenu from '../pages/newsletter-opt-out/menu.json';
import newsletterOptOutFullForm from '../pages/newsletter-opt-out/forms/full.json';
import newsletterOptOutContextForm from '../pages/newsletter-opt-out/forms/context.json';
import newsletterOptOutMiniForm from '../pages/newsletter-opt-out/forms/mini.json';
import newsletterOptOutLookupForm from '../pages/newsletter-opt-out/forms/lookup.json';
import newsletterOptOutTableView from '../pages/newsletter-opt-out/views/table.json';
import newsletterOptOutCardsView from '../pages/newsletter-opt-out/views/cards.json';
import newsletterOptOutDashboardView from '../pages/newsletter-opt-out/views/dashboard.json';

/** Тип запису «Відмова від розсилки» зі сторінками пакета: меню, форми та подання з pages/newsletter-opt-out/. */
export const newsletterOptOutDefinition: IRecordTypeDefinition = {
  ...newsletterOptOutEntity,
  views: assembleViewSet({
      table: newsletterOptOutTableView,
      cards: newsletterOptOutCardsView,
      dashboard: newsletterOptOutDashboardView,
  }),
  form: newsletterOptOutFullForm,
  forms: { full: newsletterOptOutFullForm, context: newsletterOptOutContextForm, mini: newsletterOptOutMiniForm, lookup: newsletterOptOutLookupForm },
  menu: newsletterOptOutMenu,
} as IRecordTypeDefinition;
